<template lang="pug">
.collapse(
  v-if="$store.getters.selectedMatch ? $store.getters.selectedMatch == source.matchId && source.ptype == 30 : source.ptype == 30"
  :id="'league-' + source.groupId"
  :aria-labelledby="source.groupId"
  :class="[0,1,2,3,4,5,6].includes($dayjs().day()) && ['today','parlay'].includes(menu1) || [0,1,2,3,4,5,6].includes($dayjs().day()) && ['early'].includes(menu1) && ['parlay'].includes(menu3) || ['0','1','2','3','4','5','6'].includes(selectedDays) && ['early'].includes(menu1) || ['event'].includes(menu0) && ['early'].includes(menu1) ? '' : 'show'"
)
  .card-body.p-0
    .match(:class="[(source.marketId == 3) ? 'live' : [41, 42, 43, 44, 47].includes(source.sportsId) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
      .match-info(v-if="![40].includes(source.sportsId)")
        .d-flex.match-info-team
          .match-info-home-name(:class="source.details['team'] == 1 ? 'team-red' : 'team-black'")
            .foul-card(v-if="source.matchBody[24] > 0 && source.matchBody[4] == 3")
              img(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'")
            .name {{ source.homeTeam }}
          TimePanel(:source="source")
          .match-info-away-name(:class="source.details['team'] == 0 ? 'team-red' : 'team-black'")
            .name {{ source.awayTeam }}
            .foul-card(v-if="source.matchBody[25] > 0 && source.matchBody[4] == 3")
              img(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'")
      .match-mainmarket.mmo(v-if="mmoMode && menu3 != 'parlay'")
        MatchHDPOUMMOOdds(
          v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
      .match-mainmarket
        MatchHDPOU1X2Odds(
          v-if="source.betTypeId == 'hdpou' && [1, 23, 26, 27].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
        //- MatchHDPOU1X2FTOdds(
        //-   v-if="source.betTypeId == 'hdpou' && [12].includes(source.sportsId) && source.hasOwnProperty('details')"
        //-   :index="index"
        //-   :source="source"
        //- )
        MatchHDPOUMLFTOdds(
          v-if="source.betTypeId == 'hdpou' && [41, 42, 43, 44, 47].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
        MatchHDPOUOEOdds(
          v-if="source.betTypeId == 'hdpou' && [2].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
        MatchHDPOUMLOdds(
          v-if="source.betTypeId == 'hdpou' && ![1, 2, 23, 26, 27, 41, 42, 43, 44, 47].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
        MatchHDPOUMAINOdds(
          v-if="source.betTypeId == 'hdpou' && [3].includes(source.marketId) && [20, 41, 42, 47].includes(source.sportsId) && source.hasOwnProperty('details')"
          :index="index"
          :source="source"
        )
      //- small {{ source }}
      .d-flex.justify-content-between.match-function
        .d-flex
          .mr-2.icon-function.bg-star(@click="xSetFav($event)" :class="xIsFav() == true ? 'active' : ''")
          .mr-2.icon-function(v-if="source && source.betTypeId != 'parlay'")
            template(v-if="isEFight(source)")
              template(v-if="countDown > 0")
                small {{ countDown }}s
              template(v-else)
                template(v-if="source.channelId")
                  img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'" @click="handleMore(source, 0)")
                template(v-else)
                  template(v-if="source.channelId >= 1")
                    img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
            template(v-else)
              template(v-if="source.channelId")
                img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'" @click="handleMore(source, 0)")
              template(v-else)
                template(v-if="source.channelId >= 1")
                  img(:src="(source.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
          .mr-2.icon-function
            template(v-if="source.stats")
              img(:src="(source.marketId == 3) ? '/images/statistics-live.svg?v=12' : '/images/statistics.svg?v=12'" @click="xLinkStats(source)")
          //- .mr-2.icon-function.active.flex-grow-1(v-if="source.isTimeMachine") 
          //-   img(:src="(source.marketId == 3) ? '/images/live-timemachine.svg?v=1' : '/images/timemachine.svg?v=1'" @click="showTimeMachine(source)") 
        .mr-0.more(v-if="source.details.more > 0")
          a.text-dark(href='javascript:void(0);' @click="handleMore(source)")
            | {{ $t("ui.more_markets") }} 
            span.more-number {{ source.details.more }}
            i.fas.fa-chevron-right.ml-2
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import mixinTypes from "@/library/mixinTypes";
import TimePanel from "@/components/mobile/main/timePanel";
import MatchHDPOUOEOdds from "@/components/mobile/main/xmatch/matchHDPOUOEOdds";
import MatchHDPOUMLOdds from "@/components/mobile/main/xmatch/matchHDPOUMLOdds";
import MatchHDPOUMLFTOdds from "@/components/mobile/main/xmatch/matchHDPOUMLFTOdds";
import MatchHDPOU1X2Odds from "@/components/mobile/main/xmatch/matchHDPOU1X2Odds";
import MatchHDPOU1X2FTOdds from "@/components/mobile/main/xmatch/matchHDPOU1X2FTOdds";
import MatchHDPOUMAINOdds from "@/components/mobile/main/xmatch/matchHDPOUMAINOdds";

import MatchHDPOUMMOOdds from "@/components/mobile/main/xmatch/matchHDPOUMMOOdds";

export default {
  components: {
    TimePanel,
    MatchHDPOUOEOdds,
    MatchHDPOUMLOdds,
    MatchHDPOUMLFTOdds,
    MatchHDPOU1X2Odds,
    MatchHDPOU1X2FTOdds,
    MatchHDPOUMAINOdds,
    MatchHDPOUMMOOdds
  },
  mixins: [mixinTypes],
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object
    }
  },
  data() {
    return {
      fav: false,
      countDown: 0,
      ticker: null
    };
  },
  destroyed() {
    if (this.ticker) {
      clearTimeout(this.ticker);
    }
  },
  mounted() {
    if (this.favorite) {
      var isAll = true;
      var items = this.source.matches;
      for (var n in items) {
        if (this.favorite.indexOf(items[n][2]) == -1) {
          isAll = false;
        }
      }
      this.fav = isAll;
    }

    if (this.source) {
      if (this.isEFight(this.source) && this.source.marketId == 3) {
        this.getCountDown();
      }
    }

    if (this.menu0 == "favorite") {
      this.fav = true;
    }

    this.syncGroupCollapse();

    this.$nextTick(() => {
      var firstLeague = $(".main-item div:first");
      var childLeague = $(firstLeague).attr("data-target");

      // console.log($(childLeague + ".collapse"));
      if (firstLeague.hasClass("collapsed")) {
        firstLeague.addClass("collapsed").attr("aria-expanded", "false");
        setTimeout(() => {
          $(childLeague + ".collapse").removeClass("show");
        }, 100);
      } else {
        firstLeague.removeClass("collapsed").attr("aria-expanded", "true");
        setTimeout(() => {
          $(childLeague + ".collapse").addClass("show");
        }, 100);
      }
    });
  },
  methods: {
    // Rows always render closed on Today, so a match arriving with the progressive full list would show
    // collapsed under a league the user already opened. Follow whatever the rest of the group is doing.
    syncGroupCollapse() {
      var groupId = this.source ? this.source.groupId : null;
      if (!groupId || !this.$el || !this.$el.classList) {
        return;
      }
      var panels = document.querySelectorAll("[id='league-" + groupId + "']");
      for (var i = 0; i < panels.length; i++) {
        if (panels[i] !== this.$el && panels[i].classList.contains("show")) {
          this.$el.classList.add("show");
          return;
        }
      }
    },
    isEFight(e) {
      if (e && e.sportsId) return config.vg1.includes(e.sportsId);
      else return false;
    },
    getCountDown() {
      this.ticker = setTimeout(() => {
        this.countDown = this.$dayjs(this.source.matchTime)
          .add(10, "s")
          .diff(this.$dayjs(), "s");
        if (this.countDown >= 0) {
          this.getCountDown();
        }
      }, 1000);
    },
    handleMore(source, e) {
      this.$store.dispatch("layout/setSelectedMatch", source.matchId);
      this.$store.dispatch("layout/setSelectedMatchMore", source);
      this.$store.dispatch("layout/setRadarId", source.radarId);
      this.$store.dispatch("layout/setChannelId", source.channelId);
      if (e >= 0) {
        this.$router.push({ name: "more", params: { mode: e } }).catch(err => {});
      } else {
        this.$router.push("/more").catch(err => {});
      }
    },
    showTimeMachine(source) {
      this.$store.dispatch("layout/setShowTimeMachine", true);
      EventBus.$emit("GET_TM", source);
    },
    xIsFav() {
      if (this.favorite) {
        if (this.favorite.indexOf(this.source.matchId) != -1) {
          return true;
        }
      }
      return false;
    },
    xSetFav(evt) {
      var favList = [];
      if (favList.indexOf(this.source.matchId) == -1) {
        favList.push(this.source.matchId);
      }
      if (this.xIsFav(this.source.matchId)) {
        this.$store.dispatch("layout/delFavorite", favList);
      } else {
        this.$store.dispatch("layout/setFavorite", favList);
      }
      if (this.menu0 == "favorite") {
        setTimeout(() => {
          EventBus.$emit("GET_MARKET");
        }, 500);
      }
    },
    xLinkStats(e) {
      if (e && e.stats) {
        var url = config.statscenterUrl() + e.stats + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken + "&l=" + this.$store.getters.language;
        window.open(url, "_blank", "stats", "top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no");
      }
    }
  }
};
</script>
